export enum UmamiEvent {
	APP_INIT = 'app_init',
	CONFIGURATION_STARTED = 'configuration_started',
	CONFIGURATION_SUBMITTED = 'configuration_submitted',
	SENT_OFFER = 'sent_offer',
	CHECKOUT_CART = 'checkout_cart',
}

interface UmamiSubmitMeta {
	CONFIGURATION_COMPLEXITY?: number;
}

interface UmamiSentOfferMeta {
	CONFIGURATIONS_QUANTITY?: number;
}

interface UmamiCheckoutCartMeta {
	revenue: number;
	currency: string;
}

type EventMeta = UmamiSubmitMeta | UmamiSentOfferMeta | UmamiCheckoutCartMeta;

class UmamiApi {
	private get client() {
		if (typeof window === 'undefined') return undefined;
		return (window as { umami?: { track: (event: string, data?: EventMeta) => void } })
			.umami;
	}

	constructor() {}

	emit(event: UmamiEvent.APP_INIT | UmamiEvent.CONFIGURATION_STARTED): void;
	emit(event: UmamiEvent.CONFIGURATION_SUBMITTED, meta: UmamiSubmitMeta): void;
	emit(event: UmamiEvent.SENT_OFFER, meta: UmamiSentOfferMeta): void;
	emit(event: UmamiEvent.CHECKOUT_CART, meta: UmamiCheckoutCartMeta): void;

	emit(event: UmamiEvent, meta?: EventMeta) {
		if (process.env.NODE_ENV === 'development') return;

		this.client?.track(event, meta);
	}
}

export default new UmamiApi();
